/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L5_NInputs */

const en_mk_sec_pg_l5_n = /** @type {(inputs: Mk_Sec_Pg_L5_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All traffic uses TLS.`)
};

const id_mk_sec_pg_l5_n = /** @type {(inputs: Mk_Sec_Pg_L5_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seluruh lalu lintas memakai TLS.`)
};

/**
* | output |
* | --- |
* | "All traffic uses TLS." |
*
* @param {Mk_Sec_Pg_L5_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l5_n = /** @type {((inputs?: Mk_Sec_Pg_L5_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L5_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l5_n(inputs)
	return en_mk_sec_pg_l5_n(inputs)
});